export enum SidePanelPosition {
  IS_RIGHT = 'is-right',
  IS_LEFT = 'is-left'
}